import React from 'react';
import GradientSpinner from './GradientSpinner';
import '../App.css';

/**
 * Full-screen overlay: animated loader + Stripe “coming soon” (no real checkout until keys exist).
 */
const PaymentsComingSoonModal = ({ isOpen, onClose, title = 'Payments' }) => {
  if (!isOpen) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="payments-soon-title"
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 10000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        background: 'rgba(10, 14, 20, 0.75)',
        backdropFilter: 'blur(8px)'
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          position: 'relative',
          maxWidth: '420px',
          width: '100%',
          padding: '40px 32px',
          borderRadius: '20px',
          background: 'linear-gradient(145deg, var(--bg-secondary, #1a2332) 0%, var(--bg-tertiary, #131a24) 100%)',
          border: '1px solid rgba(51, 255, 217, 0.25)',
          boxShadow: '0 24px 80px rgba(0, 0, 0, 0.45), 0 0 0 1px rgba(51, 255, 217, 0.08) inset'
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '28px' }} aria-hidden="true">
          <GradientSpinner size={72} />
        </div>
        <h2
          id="payments-soon-title"
          style={{
            margin: '0 0 12px 0',
            fontSize: '1.35rem',
            fontWeight: 700,
            textAlign: 'center',
            background: 'linear-gradient(90deg, #33ffd9, #b5ff33)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}
        >
          {title}
        </h2>
        <p style={{ margin: '0 0 8px 0', textAlign: 'center', color: 'var(--text-primary)', fontSize: '1.05rem', fontWeight: 600 }}>
          Coming soon
        </p>
        <p style={{ margin: '0 0 28px 0', textAlign: 'center', color: 'var(--text-secondary)', fontSize: '0.9rem', lineHeight: 1.55 }}>
          Secure checkout with Stripe is almost ready. You can still record payments manually (cash / check / external link) from your team.
        </p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginBottom: '24px' }}>
          <span className="payments-soon-dot" />
          <span className="payments-soon-dot payments-soon-dot--2" />
          <span className="payments-soon-dot payments-soon-dot--3" />
        </div>
        <button
          type="button"
          className="btn btn-primary"
          onClick={onClose}
          style={{ width: '100%', padding: '12px' }}
        >
          Got it
        </button>
      </div>
    </div>
  );
};

export default PaymentsComingSoonModal;
